/* Maison du Bebè — Ricerca avanzata "Nuovo stile" (stile Doofinder)
   - indice del catalogo scaricato una volta (collection.bl-index) e tenuto in memoria / localStorage
   - ricerca istantanea tollerante agli errori, sinonimi, suggerimenti categorie e marchi
   - filtri con conteggi (marchio, reparto, categoria, prezzo, disponibilità, offerte), ordinamento, "mostra altri"
   - ricerche recenti e popolari, aggiunta al carrello (gestita da bl.js)                                   */
(function () {
  'use strict';
  if (window.__blSearch) return;
  window.__blSearch = true;

  var root, cfg, input, els = {};
  var IDX = null, COLS = {}, loading = null;
  var CACHE_KEY = 'bl_search_idx_v1', CACHE_TTL = 20 * 60 * 1000;
  var state = { q: '', brands: {}, reps: {}, cats: {}, avail: false, sale: false, pmin: null, pmax: null, sort: 'rel', shown: 0 };
  var lastResults = [], lastFocus = null, timer;

  /* ---------------- utilità ---------------- */
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) {
    return String(s || '').toLowerCase()
      .replace(/³/g, '3').replace(/²/g, '2').replace(/⁵/g, '5').replace(/⁺/g, '+')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/['’`]/g, '').replace(/[^a-z0-9+]+/g, ' ').trim();
  }
  function words(s) { return norm(s).split(' ').filter(Boolean); }
  function money(c) {
    var v = (c / 100).toFixed(2).split('.');
    return '€' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
  }
  function store(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k)); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function lev(a, b, max) {
    if (a === b) return 0;
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return max + 1;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= lb; j++) prev[j] = j;
    for (i = 1; i <= la; i++) {
      cur = [i]; var best = i;
      for (j = 1; j <= lb; j++) {
        var cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) cur[j] = Math.min(cur[j], prev[j - 2] === undefined ? 99 : prev[j - 2] + cost);
        if (cur[j] < best) best = cur[j];
      }
      if (best > max) return max + 1;
      prev = cur;
    }
    return prev[lb];
  }
  function tol(w) { return w.length >= 8 ? 2 : w.length >= 4 ? 1 : 0; }

  /* titolo pulito come nelle card del tema */
  function cleanTitle(t, v) {
    var out = t;
    if (v && out.toLowerCase().indexOf(v.toLowerCase() + ' ') === 0 && v.toLowerCase().indexOf('maison') < 0) {
      out = out.slice(v.length + 1); out = out.charAt(0).toUpperCase() + out.slice(1);
    }
    out = out.replace(/\s*-?\s*paga in 3 rate.*$/i, '').replace(/\s+-\s+\d{3,5}w?\s*$/i, '').replace(/\s+\d{3,5}w?$/i, '').trim();
    return out;
  }

  /* ---------------- indice ---------------- */
  function prep(list) {
    list.forEach(function (p, i) {
      p.r = i;                                  // posizione nei più venduti
      p.k = p.k ? p.k.split(' ') : [];
      p.tw = words(p.t);
      p.vw = words(p.v);
      p.sw = norm(p.s);
      p.off = p.c > p.p ? Math.round((p.c - p.p) * 100 / p.c) : 0;
    });
    TOKC = {}; TOKN = 0;
    return list;
  }
  /* categorie valide = collezioni esistenti, con prodotti, dentro uno dei reparti del menu
     (esclude i tag tecnici dei feed, es. home-trovaprezzi). Calcolate al primo uso, quando COLS è pronto. */
  function validCat(h) {
    var c = COLS[h]; if (!c || !c.n) return false;
    return (cfg.reparti || []).some(function (r) { return h === r.h || h.indexOf(r.h + '-') === 0; });
  }
  function cats(p) {
    if (p.leaf && p.colsReady === !!Object.keys(COLS).length) return p;
    var k = p.k.filter(validCat), ks = ' ' + k.join(' ') + ' ';
    p.leaf = k.filter(function (h) { return ks.indexOf(' ' + h + '-') < 0 && !(cfg.reparti || []).some(function (r) { return r.h === h; }); });
    p.rep = k.filter(function (h) { return (cfg.reparti || []).some(function (r) { return r.h === h; }); });
    var w = []; k.forEach(function (h) { w = w.concat(words(COLS[h].t)); });
    p.cw = w; p.colsReady = !!Object.keys(COLS).length;
    return p;
  }
  function catWords(p) { return cats(p).cw; }
  function fetchJSON(url) { return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) { return JSON.parse(t); }); }
  function loadCols() {
    var cached = store('bl_search_cols_v1');
    if (cached && Date.now() - cached.ts < CACHE_TTL) { COLS = cached.c; return Promise.resolve(); }
    var out = {};
    function page(n) {
      return fetchJSON(cfg.collectionsUrl + '.json?limit=250&page=' + n).then(function (d) {
        (d.collections || []).forEach(function (c) { out[c.handle] = { t: c.title, n: c.products_count || 0 }; });
        if ((d.collections || []).length === 250 && n < 6) return page(n + 1);
      });
    }
    return page(1).then(function () { COLS = out; store('bl_search_cols_v1', { ts: Date.now(), c: out }); }).catch(function () {});
  }
  function loadIndex() {
    if (IDX) return Promise.resolve(IDX);
    if (loading) return loading;
    var cached = store(CACHE_KEY);
    var colsP = loadCols();
    if (cached && cached.p && Date.now() - cached.ts < CACHE_TTL) {
      IDX = prep(cached.p);
      loading = colsP.then(function () { return IDX; });
      return loading;
    }
    var base = cfg.indexUrl + '?view=bl-index&sort_by=best-selling&page=';
    loading = fetchJSON(base + 1).then(function (first) {
      var reqs = [];
      for (var n = 2; n <= first.pages; n++) reqs.push(fetchJSON(base + n));
      return Promise.all(reqs).then(function (rest) {
        var all = first.p;
        rest.forEach(function (d) { all = all.concat(d.p); });
        store(CACHE_KEY, { ts: Date.now(), p: all });
        IDX = prep(all);
        return colsP.then(function () { return IDX; });
      });
    }).catch(function (e) { loading = null; throw e; });
    return loading;
  }

  /* ---------------- sinonimi ---------------- */
  var SYN = [];
  function parseSyn() {
    SYN = (cfg.synonyms || []).map(function (l) {
      return l.split(/[,=|]/).map(function (x) { return norm(x); }).filter(Boolean);
    }).filter(function (g) { return g.length > 1; });
  }
  function variants(q) {
    var nq = ' ' + norm(q) + ' ', out = [nq.trim()];
    SYN.forEach(function (g) {
      g.forEach(function (a) {
        if (nq.indexOf(' ' + a + ' ') >= 0) {
          g.forEach(function (b) { if (b !== a) out.push(nq.replace(' ' + a + ' ', ' ' + b + ' ').trim()); });
        }
      });
    });
    return out.slice(0, 8);
  }

  /* ---------------- punteggio ---------------- */
  function scoreToken(tok, p) {
    var best = 0, i, w, t = tol(tok);
    for (i = 0; i < p.tw.length; i++) {
      w = p.tw[i];
      if (w === tok) { best = Math.max(best, 10); break; }
      if (w.indexOf(tok) === 0) best = Math.max(best, tok.length >= 3 ? 8 : 5);
      else if (tok.length >= 3 && w.indexOf(tok) > 0) best = Math.max(best, 4);
      else if (t && best < 6 && lev(tok, w.slice(0, Math.max(tok.length, Math.min(w.length, tok.length + 1))), t) <= t) best = Math.max(best, 5);
      else if (t && best < 5 && lev(tok, w, t) <= t) best = Math.max(best, 5);
    }
    if (best < 10) {
      for (i = 0; i < p.vw.length; i++) {
        w = p.vw[i];
        if (w === tok) { best = Math.max(best, 9); break; }
        if (w.indexOf(tok) === 0) best = Math.max(best, 7);
        else if (t && lev(tok, w, t) <= t) best = Math.max(best, 5);
      }
    }
    if (best < 6) {
      var cw = catWords(p);
      for (i = 0; i < cw.length; i++) {
        w = cw[i];
        if (w === tok || w.indexOf(tok) === 0 || (tok.length >= 5 && tok.indexOf(w.slice(0, 5)) === 0)) { best = Math.max(best, 4); break; }
        if (t && lev(tok, w, t) <= t) best = Math.max(best, 3);
      }
    }
    if (best < 10 && tok.length >= 3 && p.sw && p.sw.indexOf(tok) >= 0) best = Math.max(best, 9);
    return best;
  }
  /* cache dei punteggi per parola: i filtri e le parole già digitate non si ricalcolano */
  var TOKC = {}, TOKN = 0;
  function tokScores(tok) {
    var a = TOKC[tok];
    if (a) return a;
    if (++TOKN > 300) { TOKC = {}; TOKN = 1; }
    a = new Float32Array(IDX.length);
    for (var i = 0; i < IDX.length; i++) a[i] = scoreToken(tok, IDX[i]);
    return (TOKC[tok] = a);
  }
  function scoreQuery(toks, p) {
    var total = 0, miss = 0;
    for (var i = 0; i < toks.length; i++) {
      var s = tokScores(toks[i])[p.r];
      if (!s && toks[i].length > 2) return { s: 0, miss: 1 };   /* parola importante assente: escluso */
      total += s;                                                /* parole brevi (es. "0", "6+") non obbligatorie */
    }
    return { s: total, miss: miss };
  }
  function search(q) {
    var vs = variants(q), res = new Map();
    vs.forEach(function (vq, vi) {
      var toks = vq.split(' ').filter(Boolean);
      if (!toks.length) return;
      IDX.forEach(function (p) {
        var r = scoreQuery(toks, p);
        if (r.s > 0 && !r.miss) {
          var sc = r.s / toks.length - (vi ? 0.5 : 0);
          var prev = res.get(p);
          if (!prev || prev < sc) res.set(p, sc);
        }
      });
    });
    var out = [];
    res.forEach(function (sc, p) {
      sc += p.a ? 1.5 : 0;
      sc += Math.max(0, 1.2 - p.r / 400);
      // frase intera nel titolo
      var nt = ' ' + norm(p.t) + ' ', nq = norm(q), qt = nq.split(' ');
      if (nt.indexOf(' ' + nq) >= 0) sc += 3;
      // titoli corti e "centrati" sulla ricerca prima degli accessori ("… per Tripp Trapp")
      sc += 2.5 * Math.min(1, qt.length / Math.max(1, p.tw.length - 1));
      if (qt[0] && qt[0].length > 2 && nt.indexOf(' per ' + qt[0].slice(0, 4)) >= 0) sc -= 2.5;
      out.push({ p: p, s: sc });
    });
    out.sort(function (a, b) { return b.s - a.s || a.p.r - b.p.r; });
    return out.map(function (x) { return x.p; });
  }
  function didYouMean(q) {
    var toks = words(q); if (!toks.length) return '';
    var vocab = {};
    IDX.forEach(function (p) { p.tw.concat(p.vw).forEach(function (w) { if (w.length > 2) vocab[w] = (vocab[w] || 0) + 1; }); });
    var changed = false;
    var fixed = toks.map(function (t) {
      if (vocab[t]) return t;
      var best = t, bd = 3, bn = 0;
      Object.keys(vocab).forEach(function (w) {
        if (Math.abs(w.length - t.length) > 2) return;
        var d = lev(t, w, 2);
        if (d < bd || (d === bd && vocab[w] > bn)) { bd = d; best = w; bn = vocab[w]; }
      });
      if (best !== t && bd <= 2) changed = true;
      return bd <= 2 ? best : t;
    });
    return changed ? fixed.join(' ') : '';
  }

  /* ---------------- filtri ---------------- */
  function passes(p, skip) {
    cats(p);
    if (skip !== 'brand' && Object.keys(state.brands).length && !state.brands[p.v]) return false;
    if (skip !== 'rep' && Object.keys(state.reps).length && !p.rep.some(function (h) { return state.reps[h]; })) return false;
    if (skip !== 'cat' && Object.keys(state.cats).length && !p.leaf.some(function (h) { return state.cats[h]; })) return false;
    if (skip !== 'price') {
      if (state.pmin != null && p.p < state.pmin * 100) return false;
      if (state.pmax != null && p.p > state.pmax * 100) return false;
    }
    if (skip !== 'avail' && state.avail && !p.a) return false;
    if (skip !== 'sale' && state.sale && !p.off) return false;
    return true;
  }
  function nFilters() {
    return Object.keys(state.brands).length + Object.keys(state.reps).length + Object.keys(state.cats).length +
      (state.pmin != null || state.pmax != null ? 1 : 0) + (state.avail ? 1 : 0) + (state.sale ? 1 : 0);
  }
  function count(list, skip, keyFn) {
    var m = {};
    list.forEach(function (p) {
      if (!passes(p, skip)) return;
      var ks = keyFn(p); if (!Array.isArray(ks)) ks = [ks];
      ks.forEach(function (k) { if (k) m[k] = (m[k] || 0) + 1; });
    });
    return m;
  }
  function facetList(title, key, counts, selected, labelFn, limit) {
    var keys = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a] || labelFn(a).localeCompare(labelFn(b)); });
    Object.keys(selected).forEach(function (k) { if (keys.indexOf(k) < 0) keys.unshift(k); });
    if (!keys.length) return '';
    var html = '<details class="bls__facet" open><summary>' + esc(title) + (Object.keys(selected).length ? ' <span class="bls__n">' + Object.keys(selected).length + '</span>' : '') + '</summary><ul role="list" class="bls__opts' + (keys.length > limit ? ' is-clamped' : '') + '">';
    keys.forEach(function (k, i) {
      html += '<li' + (i >= limit ? ' class="bls__more-opt"' : '') + '><label class="bls__opt"><input type="checkbox" data-facet="' + key + '" value="' + esc(k) + '"' + (selected[k] ? ' checked' : '') + '><span>' + esc(labelFn(k)) + '</span><small>' + (counts[k] || 0) + '</small></label></li>';
    });
    html += '</ul>';
    if (keys.length > limit) html += '<button type="button" class="bls__showall" data-bls-showall>Mostra tutti (' + keys.length + ')</button>';
    return html + '</details>';
  }
  function renderFacets(list) {
    var catTitle = function (h) { return (COLS[h] && COLS[h].t) || h.replace(/^home-/, '').replace(/-/g, ' '); };
    var repTitle = function (h) { var r = (cfg.reparti || []).filter(function (x) { return x.h === h; })[0]; return r ? r.t : catTitle(h); };
    var html = '';
    html += facetList('Marchio', 'brand', count(list, 'brand', function (p) { return p.v; }), state.brands, function (k) { return k; }, 8);
    html += facetList('Reparto', 'rep', count(list, 'rep', function (p) { return p.rep; }), state.reps, repTitle, 9);
    html += facetList('Categoria', 'cat', count(list, 'cat', function (p) { return p.leaf; }), state.cats, catTitle, 8);
    // prezzo
    var inPrice = list.filter(function (p) { return passes(p, 'price'); });
    var maxP = Math.ceil(Math.max.apply(null, inPrice.map(function (p) { return p.p / 100; }).concat([1])));
    var ranges = [[0, 50], [50, 150], [150, 300], [300, 600], [600, null]];
    html += '<details class="bls__facet" open><summary>Prezzo' + (state.pmin != null || state.pmax != null ? ' <span class="bls__n">1</span>' : '') + '</summary><div class="bls__price">';
    html += '<div class="bls__ranges">';
    ranges.forEach(function (r) {
      var n = inPrice.filter(function (p) { var e = p.p / 100; return e >= r[0] && (r[1] == null || e < r[1]); }).length;
      if (!n) return;
      var act = state.pmin === r[0] && state.pmax === (r[1] == null ? null : r[1]);
      html += '<button type="button" class="bl-chip' + (act ? ' is-active' : '') + '" data-range="' + r[0] + '-' + (r[1] == null ? '' : r[1]) + '">' + (r[1] == null ? 'oltre ' + r[0] + ' €' : r[0] ? r[0] + '–' + r[1] + ' €' : 'fino a ' + r[1] + ' €') + ' <small>' + n + '</small></button>';
    });
    html += '</div><div class="bls__pinputs"><label>Da €<input type="number" inputmode="numeric" min="0" data-pmin value="' + (state.pmin != null ? state.pmin : '') + '" placeholder="0"></label><label>A €<input type="number" inputmode="numeric" min="0" data-pmax value="' + (state.pmax != null ? state.pmax : '') + '" placeholder="' + maxP + '"></label></div></div></details>';
    // disponibilità e offerte
    var nAv = count(list, 'avail', function (p) { return p.a ? 'y' : ''; }).y || 0;
    var nSale = count(list, 'sale', function (p) { return p.off ? 'y' : ''; }).y || 0;
    html += '<details class="bls__facet" open><summary>Altro</summary><ul role="list" class="bls__opts">' +
      '<li><label class="bls__opt"><input type="checkbox" data-flag="avail"' + (state.avail ? ' checked' : '') + '><span>Solo disponibili</span><small>' + nAv + '</small></label></li>' +
      (nSale ? '<li><label class="bls__opt"><input type="checkbox" data-flag="sale"' + (state.sale ? ' checked' : '') + '><span>Solo in offerta</span><small>' + nSale + '</small></label></li>' : '') +
      '</ul></details>';
    els.facets.innerHTML = html;
  }
  function renderActive() {
    var chips = [];
    Object.keys(state.brands).forEach(function (k) { chips.push(['brand', k, k]); });
    Object.keys(state.reps).forEach(function (k) { var r = (cfg.reparti || []).filter(function (x) { return x.h === k; })[0]; chips.push(['rep', k, r ? r.t : k]); });
    Object.keys(state.cats).forEach(function (k) { chips.push(['cat', k, (COLS[k] && COLS[k].t) || k]); });
    if (state.pmin != null || state.pmax != null) chips.push(['price', '', (state.pmin != null ? 'da ' + state.pmin + ' € ' : '') + (state.pmax != null ? 'a ' + state.pmax + ' €' : '')]);
    if (state.avail) chips.push(['avail', '', 'Solo disponibili']);
    if (state.sale) chips.push(['sale', '', 'Solo in offerta']);
    els.active.innerHTML = chips.length ? chips.map(function (c) {
      return '<button type="button" class="bl-chip is-active" data-remove="' + c[0] + '" data-value="' + esc(c[1]) + '">' + esc(c[2]) + ' <span aria-hidden="true">×</span><span class="visually-hidden">(rimuovi)</span></button>';
    }).join('') + '<button type="button" class="bl-link" data-clear-all>Rimuovi tutti</button>' : '';
    var n = nFilters();
    els.nfilters.textContent = n ? '(' + n + ')' : '';
  }

  /* ---------------- risultati ---------------- */
  function highlight(title, q) {
    var toks = words(q).filter(function (t) { return t.length > 1; });
    if (!toks.length) return esc(title);
    return title.split(/(\s+)/).map(function (part) {
      var n = norm(part);
      var hit = n && toks.some(function (t) { return n.indexOf(t) === 0 || (t.length > 2 && n.indexOf(t) > 0) || (tol(t) && (lev(t, n, tol(t)) <= tol(t) || lev(t, n.slice(0, t.length), tol(t)) <= tol(t))); });
      return hit ? '<mark>' + esc(part) + '</mark>' : esc(part);
    }).join('');
  }
  function card(p, q) {
    var url = '/products/' + p.h;
    var title = cleanTitle(p.t, p.v);
    var brand = p.v && p.v.toLowerCase().indexOf('maison') < 0 ? p.v : '';
    var badges = '';
    if (p.off) badges += '<span class="bl-badge">-' + p.off + '%</span>';
    if (!p.a) badges += '<span class="bl-badge bl-badge--soft">Esaurito</span>';
    var btn;
    if (p.m) btn = '<a class="bl-add" href="' + url + '">Scegli</a>';
    else btn = '<button type="button" class="bl-add" data-variant="' + p.id + '" data-title="' + esc(title) + '"' + (p.a ? '' : ' disabled') + ' aria-label="Aggiungi al carrello: ' + esc(title) + '">' + (p.a ? 'Aggiungi' : 'Esaurito') + '</button>';
    var heart = '<button type="button" class="bl-ln-heart" data-ln-heart data-ln-epi="' + p.id + '" data-ln-handle="' + esc(p.h) + '" data-ln-title="' + esc(title) + '"' + (p.i ? ' data-ln-image="' + esc(p.i) + '"' : '') + ' aria-pressed="false" aria-label="Aggiungi alla lista nascita: ' + esc(title) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.2-9.4C1.6 7.7 3.8 4.5 7.1 4.5c2 0 3.6 1.1 4.9 2.9 1.3-1.8 2.9-2.9 4.9-2.9 3.3 0 5.5 3.2 4.3 6.6-1.7 4.8-9.2 9.4-9.2 9.4z"/></svg></button>';
    return '<li><article class="bl-card">' + heart + '<a class="bl-card__media" href="' + url + '" tabindex="-1" aria-hidden="true" data-bls-go>' +
      (badges ? '<span class="bl-card__badges">' + badges + '</span>' : '') +
      (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="300" height="300">' : '') + '</a>' +
      '<div class="bl-card__body">' + (brand ? '<p class="bl-card__type">' + esc(brand) + '</p>' : '') +
      '<h3 class="bl-card__title"><a href="' + url + '" data-bls-go>' + highlight(title, q) + '</a></h3>' +
      '<div class="bl-card__foot"><span class="bl-price">' + (p.m ? '<small>da</small>' : '') + money(p.p) + (p.c > p.p ? '<s>' + money(p.c) + '</s>' : '') + '</span>' + btn + '</div></div></article></li>';
  }
  function sortList(list) {
    var l = list.slice();
    if (state.sort === 'asc') l.sort(function (a, b) { return a.p - b.p; });
    else if (state.sort === 'desc') l.sort(function (a, b) { return b.p - a.p; });
    else if (state.sort === 'off') l.sort(function (a, b) { return b.off - a.off || a.r - b.r; });
    else if (state.sort === 'pop') l.sort(function (a, b) { return a.r - b.r; });
    return l;
  }
  function renderSuggest(q, matched) {
    if (!q) { els.suggest.innerHTML = ''; return; }
    var nq = norm(q), toks = words(q), out = [], seen = {};
    /* categorie: quelle più presenti tra i primi risultati + quelle il cui nome contiene la ricerca */
    var freq = {};
    (matched || []).slice(0, 60).forEach(function (p) { cats(p).leaf.forEach(function (h) { freq[h] = (freq[h] || 0) + 1; }); });
    Object.keys(COLS).forEach(function (h) {
      if (!validCat(h)) return;
      var tn = norm(COLS[h].t);
      if (tn.indexOf(nq) >= 0 || toks.every(function (t) { return tn.split(' ').some(function (w) { return w.indexOf(t) === 0; }); })) freq[h] = (freq[h] || 0) + 100;
    });
    Object.keys(freq).filter(function (h) { return freq[h] >= 2; }).sort(function (a, b) { return freq[b] - freq[a]; }).slice(0, 4).forEach(function (h) {
      seen[h] = 1; out.push({ t: COLS[h].t, u: cfg.collectionsUrl + '/' + h, n: COLS[h].n, k: 'Categoria' });
    });
    /* marchi */
    var brands = {};
    IDX.forEach(function (p) { brands[p.v] = (brands[p.v] || 0) + 1; });
    Object.keys(brands).forEach(function (b) {
      var bn = norm(b);
      if (bn.indexOf(nq) === 0 || toks.some(function (t) { return t.length > 2 && (bn.indexOf(t) === 0 || lev(t, bn, tol(t)) <= tol(t)); })) {
        var h = bn.replace(/ /g, '-');
        out.push({ t: b, u: COLS[h] ? cfg.collectionsUrl + '/' + h : cfg.collectionsUrl + '/vendors?q=' + encodeURIComponent(b), n: brands[b], k: 'Marchio' });
      }
    });
    out = out.slice(0, 6);
    els.suggest.innerHTML = out.length ? '<div class="bls__sugg"><p class="bls__label">Suggerimenti</p><ul role="list">' + out.map(function (o) {
      return '<li><a href="' + o.u + '" data-bls-go><span>' + esc(o.t) + '</span><small>' + o.k + ' · ' + o.n + ' prodotti</small></a></li>';
    }).join('') + '</ul></div>' : '';
  }
  function run(keepShown) {
    var q = state.q.trim();
    els.clear.hidden = !q;
    root.classList.toggle('has-query', !!q);
    if (!q) { showEmpty(); return; }
    if (!IDX) { els.loading.hidden = false; loadIndex().then(function () { els.loading.hidden = true; run(); }).catch(showError); return; }
    els.empty.innerHTML = ''; els.results.hidden = false;
    var matched = search(q), notice = '';
    if (!matched.length) {
      var dym = didYouMean(q);
      if (dym) { matched = search(dym); if (matched.length) notice = 'Nessun risultato per <strong>“' + esc(q) + '”</strong>. Ti mostriamo i risultati per <button type="button" class="bl-link" data-bls-q="' + esc(dym) + '">' + esc(dym) + '</button>.'; }
    }
    lastResults = matched;
    renderSuggest(q, matched);
    renderFacets(matched);
    renderActive();
    var list = sortList(matched.filter(function (p) { return passes(p); }));
    els.notice.hidden = !notice; els.notice.innerHTML = notice;
    els.count.innerHTML = list.length ? '<strong>' + list.length + '</strong> ' + (list.length === 1 ? 'risultato' : 'risultati') + ' per “' + esc(q) + '”' : '';
    if (!list.length) {
      els.grid.innerHTML = '';
      els.count.innerHTML = matched.length ? 'Nessun prodotto con questi filtri.' : 'Nessun risultato per “' + esc(q) + '”.';
      if (!matched.length) els.empty.innerHTML = emptyHTML(true);
      els.more.hidden = true;
    } else {
      state.shown = keepShown ? Math.max(state.shown, cfg.perPage) : cfg.perPage;
      els.grid.innerHTML = list.slice(0, state.shown).map(function (p) { return card(p, q); }).join('');
      els.more.hidden = list.length <= state.shown;
      els.more.textContent = 'Mostra altri (' + (list.length - state.shown) + ')';
    }
    els.all.href = cfg.searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
  }
  function more() {
    var list = sortList(lastResults.filter(function (p) { return passes(p); }));
    var from = state.shown; state.shown += cfg.perPage;
    els.grid.insertAdjacentHTML('beforeend', list.slice(from, state.shown).map(function (p) { return card(p, state.q); }).join(''));
    els.more.hidden = list.length <= state.shown;
    els.more.textContent = 'Mostra altri (' + Math.max(0, list.length - state.shown) + ')';
  }

  /* ---------------- stato vuoto ---------------- */
  function recent() { return (store('bl_search_recent') || []).slice(0, 8); }
  function addRecent(q) {
    q = (q || '').trim(); if (q.length < 2) return;
    var r = recent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    r.unshift(q); store('bl_search_recent', r.slice(0, 8));
  }
  function emptyHTML(noResults) {
    var html = '';
    if (noResults) html += '<p class="bls__none">Nessun prodotto trovato. Prova con una parola diversa o scegli un reparto.</p>';
    var rec = recent();
    if (rec.length && !noResults) {
      html += '<div class="bls__block"><div class="bls__block-head"><p class="bls__label">Ricerche recenti</p><button type="button" class="bl-link" data-bls-clear-recent>Cancella</button></div><div class="bl-chips">' +
        rec.map(function (x) { return '<button type="button" class="bl-chip" data-bls-q="' + esc(x) + '"><svg class="bl-ico" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M12 8v4l3 2"/></svg>' + esc(x) + '</button>'; }).join('') + '</div></div>';
    }
    var pop = (cfg.popular || []).map(function (x) { return x.trim(); }).filter(Boolean);
    if (pop.length) {
      html += '<div class="bls__block"><p class="bls__label">Ricerche popolari</p><div class="bl-chips">' +
        pop.map(function (x) { return '<button type="button" class="bl-chip" data-bls-q="' + esc(x) + '"><svg class="bl-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 16l5-5 4 4 7-7M15 8h5v5"/></svg>' + esc(x) + '</button>'; }).join('') + '</div></div>';
    }
    if ((cfg.reparti || []).length) {
      html += '<div class="bls__block"><p class="bls__label">Reparti</p><div class="bl-chips">' +
        cfg.reparti.map(function (r) { return '<a class="bl-chip" href="' + esc(r.u) + '" data-bls-go>' + esc(r.t) + '</a>'; }).join('') + '</div></div>';
    }
    if (IDX) {
      var top = IDX.filter(function (p) { return p.a; }).slice(0, 8);
      html += '<div class="bls__block"><p class="bls__label">I più venduti</p><ul class="bls__grid bls__grid--4" role="list">' + top.map(function (p) { return card(p, ''); }).join('') + '</ul></div>';
    }
    return html;
  }
  function showEmpty() {
    els.results.hidden = true;
    els.suggest.innerHTML = '';
    els.facets.innerHTML = '';
    els.empty.innerHTML = emptyHTML(false);
    root.classList.remove('has-query');
  }
  function showError() {
    els.loading.hidden = true;
    els.empty.innerHTML = '<p class="bls__none">Non riesco a caricare il catalogo. <a class="bl-link" href="' + cfg.searchUrl + '?q=' + encodeURIComponent(state.q) + '">Apri la pagina di ricerca</a>.</p>';
  }

  /* ---------------- apertura / chiusura ---------------- */
  function open(prefill) {
    if (!root) return;
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('bls-open');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    if (typeof prefill === 'string') { input.value = prefill; state.q = prefill; }
    setTimeout(function () { input.focus(); input.select(); }, 30);
    if (!IDX) {
      if (!state.q) showEmpty();
      loadIndex().then(function () { if (!root.hidden) run(); }).catch(function () {});
    } else run(true);
  }
  function close() {
    root.classList.remove('is-open', 'show-filters');
    document.documentElement.classList.remove('bls-open');
    setTimeout(function () { root.hidden = true; }, 180);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) {}
  }
  function resetFilters() { state.brands = {}; state.reps = {}; state.cats = {}; state.pmin = state.pmax = null; state.avail = state.sale = false; }

  /* ---------------- eventi ---------------- */
  function wire() {
    input.addEventListener('input', function () {
      var v = input.value;
      if (norm(v) !== norm(state.q)) resetFilters();
      state.q = v;
      clearTimeout(timer); timer = setTimeout(function () { run(); }, 90);
    });
    $('.bls__form').addEventListener('submit', function (e) {
      if (!state.q.trim()) { e.preventDefault(); return; }
      addRecent(state.q);
    });
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-bls-close]')) { close(); return; }
      if (t.closest('[data-bls-clear]')) { input.value = ''; state.q = ''; resetFilters(); run(); input.focus(); return; }
      var qb = t.closest('[data-bls-q]');
      if (qb) { input.value = qb.getAttribute('data-bls-q'); state.q = input.value; resetFilters(); run(); input.focus(); return; }
      if (t.closest('[data-bls-clear-recent]')) { store('bl_search_recent', []); showEmpty(); return; }
      if (t.closest('[data-bls-more]')) { more(); return; }
      if (t.closest('[data-bls-filters-open]')) { root.classList.add('show-filters'); return; }
      if (t.closest('[data-bls-filters-close]')) { root.classList.remove('show-filters'); return; }
      if (t.closest('[data-bls-showall]')) { var ul = t.closest('.bls__facet').querySelector('.bls__opts'); ul.classList.remove('is-clamped'); t.remove(); return; }
      var rg = t.closest('[data-range]');
      if (rg) {
        var parts = rg.getAttribute('data-range').split('-');
        var mn = Number(parts[0]), mx = parts[1] === '' ? null : Number(parts[1]);
        if (state.pmin === mn && state.pmax === mx) { state.pmin = state.pmax = null; } else { state.pmin = mn; state.pmax = mx; }
        run(); return;
      }
      var rm = t.closest('[data-remove]');
      if (rm) {
        var kind = rm.getAttribute('data-remove'), val = rm.getAttribute('data-value');
        if (kind === 'brand') delete state.brands[val];
        else if (kind === 'rep') delete state.reps[val];
        else if (kind === 'cat') delete state.cats[val];
        else if (kind === 'price') state.pmin = state.pmax = null;
        else state[kind] = false;
        run(); return;
      }
      if (t.closest('[data-clear-all]')) { resetFilters(); run(); return; }
      if (t.closest('[data-bls-go]') || t.closest('.bl-card__title a')) addRecent(state.q);
    });
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-facet]')) {
        var map = { brand: state.brands, rep: state.reps, cat: state.cats }[t.getAttribute('data-facet')];
        if (t.checked) map[t.value] = 1; else delete map[t.value];
        run(); return;
      }
      if (t.matches('[data-flag]')) { state[t.getAttribute('data-flag')] = t.checked; run(); return; }
      if (t.matches('[data-pmin], [data-pmax]')) {
        var a = $('[data-pmin]').value, b = $('[data-pmax]').value;
        state.pmin = a === '' ? null : Math.max(0, Number(a));
        state.pmax = b === '' ? null : Math.max(0, Number(b));
        run(); return;
      }
      if (t.matches('[data-bls-sort]')) { state.sort = t.value; run(); }
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (root.classList.contains('show-filters')) root.classList.remove('show-filters'); else close();
      }
      if (e.key === 'ArrowDown' && e.target === input) {
        var first = root.querySelector('.bls__grid .bl-card__title a'); if (first) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* intercetta tutte le aperture della ricerca (anche l'icona di Horizon) */
  function isOpener(el) {
    if (!el || !el.closest) return null;
    return el.closest('[data-bl-search-open], [on\\:click="#search-modal/showDialog"], .search-action button');
  }
  document.addEventListener('click', function (e) {
    var o = isOpener(e.target);
    if (!o || !root) return;
    e.preventDefault(); e.stopImmediatePropagation(); e.stopPropagation();
    open();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (!root || !root.hidden) return;
    var tag = (e.target.tagName || '').toLowerCase();
    if (e.key === '/' && tag !== 'input' && tag !== 'textarea' && !e.target.isContentEditable) { e.preventDefault(); open(); }
  });
  /* prefetch dell'indice quando il mouse passa sulla barra (così è pronto al clic) */
  document.addEventListener('pointerover', function (e) {
    if (root && !IDX && !loading && isOpener(e.target)) loadIndex().catch(function () {});
  }, { passive: true });

  function init() {
    root = document.getElementById('bl-search');
    if (!root) return;
    /* il pannello vive nel <body>: dentro l'header fisso il position:fixed non funzionerebbe */
    if (root.parentNode !== document.body) document.body.appendChild(root);
    var rawCfg = (document.getElementById('bl-search-config') || {}).textContent || '{}';
    try { cfg = JSON.parse(rawCfg); }
    catch (e) {
      // una virgola di troppo (es. menu che finisce con voci non-collezione) non deve bloccare la ricerca
      try { cfg = JSON.parse(rawCfg.replace(/,\s*([\]}])/g, '$1')); } catch (e2) { cfg = {}; }
    }
    var root0 = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    cfg.indexUrl = cfg.indexUrl || root0 + 'collections/all';
    cfg.collectionsUrl = cfg.collectionsUrl || root0 + 'collections';
    cfg.searchUrl = cfg.searchUrl || root0 + 'search';
    cfg.perPage = cfg.perPage || 24;
    cfg.reparti = cfg.reparti || [];
    parseSyn();
    input = $('[data-bls-input]');
    els = {
      suggest: $('[data-bls-suggest]'), facets: $('[data-bls-facets]'), empty: $('[data-bls-empty]'),
      results: $('[data-bls-results]'), count: $('[data-bls-count]'), active: $('[data-bls-active]'),
      grid: $('[data-bls-grid]'), more: $('[data-bls-more]'), all: $('[data-bls-all]'), notice: $('[data-bls-notice]'),
      loading: $('[data-bls-loading]'), clear: $('[data-bls-clear]'), nfilters: $('[data-bls-nfilters]')
    };
    // la pagina /search?q=… apre il pannello già compilato se richiesto con #cerca
    wire();
    if (location.hash === '#cerca') open('');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.blSearchOpen = function (q) { open(q); };
  if (window.__BLS_TEST) window.__BLS_TEST = { setIdx: function (l, cols, conf) { cfg = conf; COLS = cols; parseSyn(); IDX = prep(l); }, search: search, dym: function (q) { return didYouMean(q); } };
})();
